module.exports = __webpack_public_path__ + "static/media/020-bug.9dc86a43.svg";